var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header",class:_vm.headerClasses},[_c('header-logo',{staticClass:"logo"}),_c('header-navigation',{staticClass:"navigation"}),_c('div',{staticClass:"menu"},[_c('header-requests'),_c('header-app-advisor'),_c('locale-switcher'),_c('header-tray')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }